import React, { useState } from "react"
import PropTypes from "prop-types"

import Drawer from "@material-ui/core/Drawer"
import { makeStyles } from "@material-ui/core/styles"

import logo from "assets/logo-sidebar.png"
import clsx from "clsx"
import SideNavigation from "./SideNavigation"
import AppBar from "./AppBar"

const drawerWidth = 300

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    // width: `calc(100% - ${drawerWidth}px)`,
    width: `calc(100%)`,
    // marginLeft: drawerWidth,
    backgroundColor: "#033278",
  },
  appBarDesktop: {
    width: `calc(100% - ${drawerWidth}px)`,
    // width: `calc(100%)`,
    marginLeft: drawerWidth,
    backgroundColor: "#033278",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    overflowY: "scroll",
    background: theme.palette.background.default,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  companyLogo: {
    width: "calc(100% - 77px)",
    margin: "13px auto",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  contentAppBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}))

const AppPage = ({ navProps, appBarProps, children, hide }) => {
  const classes = useStyles()
  const [openDrawer, setOpenDrawer] = useState(true)

  return (
    <div className={classes.root}>
      <AppBar
        {...appBarProps}
        classes={{
          appBar: clsx(classes.appBar, { [classes.appBarShift]: openDrawer }),
        }}
        style={{
          display: hide ? "none" : null,
        }}
        onDashboardButtonClick={() => {
          setOpenDrawer(!openDrawer)
        }}
      />
      <Drawer
        // className={classes.drawer}
        variant="persistent"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
        style={{
          display: hide ? "none" : null,
        }}
      >
        <img src={logo} alt="Company Logo" className={classes.companyLogo} />
        <SideNavigation {...navProps} />
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentAppBarShift]: openDrawer,
        })}
      >
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  )
}

AppPage.propTypes = {
  navProps: PropTypes.shape({}),
  appBarProps: PropTypes.shape({}),
  children: PropTypes.node,
  hide: PropTypes.bool,
}

AppPage.defaultProps = {
  navProps: { routes: [] },
  appBarProps: {},
  children: null,
  hide: false,
}

export default AppPage
